import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipoCuenta ?
                                    { key: this.props.filter.idTipoCuenta } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Grado" />}
                            onChange={(option) => this.props.onChange("idTipoCuenta", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.tipo_PlanContable.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por Descripcion"
                            autoComplete="off"
                        />
                    </Col>

       
                </Row>
            </div>
        );
    }

}

export default Filters;